import axios from "axios";

export default {
  upload: (id, data, cancelToken) => axios.put(`/api/attached/${id}`, data),
  create: (data, cancelToken) => axios.post(`/api/attached`, data),
  delete: (id, cancelToken) => axios.delete(`/api/attached/${id}`, { cancelToken })
};
